import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route change EXCEPT when only the language segment changes.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevRef = useRef(pathname);

  useEffect(() => {
    const prev = prevRef.current || '';
    const prevParts = prev.split('/').filter(Boolean);
    const nextParts = pathname.split('/').filter(Boolean);
    const langSet = new Set(['ar', 'en']);

    // Map slugs between languages to recognize same page in different language
    const slugMap = {
      privacidad: 'privacy', privacy: 'privacidad',
      terminos: 'terms', terms: 'terminos',
      cookies: 'cookies',
    };

    const normalizeSlug = (slug) => {
      // Return the canonical form (English version) for comparison
      if (slug === 'privacidad') return 'privacy';
      if (slug === 'terminos') return 'terms';
      return slug;
    };

    const stripLang = (parts) => (parts.length && langSet.has(parts[0]) ? parts.slice(1) : parts);
    const restPrev = stripLang(prevParts).map(normalizeSlug).join('/');
    const restNext = stripLang(nextParts).map(normalizeSlug).join('/');

    const onlyLangChanged = restPrev === restNext && prev !== pathname;

    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (!onlyLangChanged) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }

    prevRef.current = pathname;
  }, [pathname, hash]);

  return null;
}
